import * as swcHelpers from '@swc/helpers';
import { useMemo } from 'react';
import { createCustomEvent } from './utils.js';

/**
 * data-element-id
    Add the custom data-element-id attribute on each element:
    English for all countries
    CamelCase for different words
    No empty spaces
    No special characters, only letters and numbers
    _ or - are reserved special characters used by us as separators

    The syntax is:
    <RowCounter><ComponentName>_<ItemType><ColumnCounter>_<Action>
    <Counter><Name>: describe the placement of a component in the page.
    If you can provide the placement counter/row number the Name can be a generic "Placement", otherwise the name must be a custom one like "Hero", "AlsoLike".
    <ItemType><Counter>: for each item in the component you must specify its type like "Banner", "Video", "Tile" (for product tiles) and a counter like the column number;
    <Action>: describe what the user clicked. Values can be:  CTA,  IMG, LINK, CARTADD, PLAY, SHOW, HIDE. 

    data-description
    Add the custom data-description attribute to describe the function/destination of each element: 
    English for all countries
    max 25 characters
    CamelCase for different words
    No empty spaces
    No special characters, only letters and numbers
    _ or - are reserved special characters used by us as separators

 * @param tealiumClickEvent 
 * @returns 
 */ function validateEvent(tealiumClickEvent) {
    if (!tealiumClickEvent.data_element_id) {
        console.error('[Tealium] [Click]: data_element_id is required for Tealium tracking');
        return false;
    }
    if (tealiumClickEvent.data_description && tealiumClickEvent.data_description.length > 25) {
        console.error('[Tealium] [Click]: data_description must be 25 characters or less');
        return false;
    }
    if (tealiumClickEvent.Tracking_Type && ![
        'link',
        'hiddenaction'
    ].includes(tealiumClickEvent.Tracking_Type)) {
        console.error('[Tealium] [Click]: Tracking_Type must be either "link" or "hiddenaction"');
        return false;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(tealiumClickEvent.data_element_id)) {
        console.error('[Tealium] [Click]: data_element_id must contain only letters, numbers, and underscores');
        return false;
    }
    if (tealiumClickEvent.data_description && !/^[a-zA-Z0-9_]+$/.test(tealiumClickEvent.data_description)) {
        console.error('[Tealium] [Click]: data_description must contain only letters, numbers, and underscores');
        return false;
    }
    return true;
}
// Hook for manually dispatching track events
function useDispatchTrackClickEvent() {
    const trackClickEventDispatcher = useMemo(()=>{
        return (event)=>{
            if (!validateEvent(event)) return;
            dispatchTrackEvent(event);
        };
    }, []);
    return trackClickEventDispatcher;
}
// Dispatch function for individual track events
function dispatchTrackEvent(event) {
    try {
        const finalEvent = createCustomEvent(swcHelpers.objectSpread({}, event, {
            id: 'Click'
        }));
        globalThis.dispatchEvent(finalEvent);
    } catch (error) {
        console.error('[Tealium] Error dispatching track event:', error);
    }
}

export { useDispatchTrackClickEvent };
//# sourceMappingURL=use-track-click-event.js.map
